import { useCallback } from 'react';
import { usePublicApplication } from '../../../../hooks/usePublicApplication';
import { useGetKitDetails } from '../../../../services/modules/kit/kitDetails/kitDetails.queries';
import { useProductDetailsProductColor } from '../../../../services/modules/productDetails/productDetails.queries';
import useOrderBookStore from '../../../../stores/OrderBook/orderBook.store';
import useIsAdminSeller from '../../../../stores/ShowUnavailableProducts/hooks/useIsAdminSeller';
import { returnOrderIdBasedOnPublicOrder } from '../../../../utils/returnOrderIdBasedOnPublicOrder';
import { DetailsModalEntity, ProductDetailsEntityType } from '../types/productDetails.types';
import useProductDetailsActions from './useProductsDetailsActions';

const useFindDetailsEntity = () => {
  const isAdminSeller = useIsAdminSeller();
  const selectedOrder = useOrderBookStore((orderBookState) => orderBookState.selectedOrder);

  const { availableProductColorId, availableKitId } = useProductDetailsActions();
  const { sharedEntity } = usePublicApplication();
  const orderId = returnOrderIdBasedOnPublicOrder(sharedEntity, selectedOrder?.id);

  const { data: product, isLoading } = useProductDetailsProductColor(
    {
      productColorId: availableProductColorId!,
      isAdminSeller,
      orderId,
    },
    { enabled: !!availableProductColorId },
  );

  const { data: kitDetails, isLoading: isKitLoading } = useGetKitDetails(availableKitId!, {
    enabled: !!availableKitId,
  });

  const mapEntity: () => DetailsModalEntity | undefined = useCallback(() => {
    if (!!product) {
      return {
        type: ProductDetailsEntityType.PRODUCT,
        data: product,
      };
    }
    if (!!kitDetails) {
      return {
        type: ProductDetailsEntityType.KIT,
        data: kitDetails,
      };
    }

    return undefined;
  }, [kitDetails, product]);

  return {
    entity: mapEntity(),
    isLoading: isLoading || isKitLoading,
  };
};

export default useFindDetailsEntity;
